import { render, staticRenderFns } from "./DashboardBoardsWidget.vue?vue&type=template&id=6673dd7f&scoped=true&"
import script from "./DashboardBoardsWidget.vue?vue&type=script&lang=ts&"
export * from "./DashboardBoardsWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673dd7f",
  null
  
)

export default component.exports